import { Pipe, PipeTransform } from '@angular/core';
import { SourceTable } from '../target-column.models';

@Pipe({
  name: 'filterFields',
})
export class FilterFieldsPipe implements PipeTransform {
  transform(value: string, sourceTable?: SourceTable | null): SourceTable['fields'] {
    if (sourceTable) {
      return sourceTable.fields.filter(
        (f) =>
          !value ||
          (f.field_name.toLowerCase() !== value.toLowerCase() &&
            f.field_name.toLowerCase().includes(value.toLowerCase())),
      );
    }
    return [];
  }
}
